import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const HeaderWrapper = styled.div({
    display: 'flex',
    alignItems: 'center',
});

export const Icon = styled(FontAwesomeIcon)({
    fontSize: 17,
    color: '#009BF2',
    marginRight: 8,
});

export const Header = styled.h2(({ theme }) => ({
    color: theme.colors.neutral900,
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '40px',
}));

export const ExampleBackground = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.pastelPrimary300,
    padding: 24,
    border: `1px solid ${theme.colors.primary300}`,
    borderRadius: 3,
}));

export const Bold = styled.span({
    fontWeight: 700,
});

export const CodeText = styled.span(({ theme }) => ({
    color: theme.colors.neutral300,
    fontStyle: 'italic',
}));

export const Text = styled.p(({ theme }) => ({
    color: theme.colors.neutral900,
    fontSize: 15,
    fontWeight: 400,
    lineHeight: '24px',
}));

export const Table = styled.table({
    borderCollapse: 'collapse',
    width: '100%',
    marginTop: 30,
});

export const TableHeader = styled.thead(({ theme }) => ({
    borderBottom: `1px solid ${theme.colors.neutral300}`,
    fontSize: 11,
    textTransform: 'uppercase',
    color: theme.colors.neutral700,
    textAlign: 'left',
}));

export const TableBody = styled.tbody({
    fontSize: 15,
})

export const TableRow = styled.tr({
    height: 22,
    lineHeight: '32px',
});

export const Acknowledgement = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});

export const CheckboxWrapper = styled.div({
    display: 'flex',
});

export const CheckboxLabel = styled.label(({ theme }) => ({
    color: theme.colors.neutral900,
    fontSize: 15,
    fontWeight: 400,
    cursor: 'pointer',
    marginLeft: 8,
}));
